import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { createCustodyWallet } from '../cryptoWalletsEndpoints'

/**
 * Mints and funds the investor's XRPL custody wallet.
 *
 * Idempotent by construction — the address is derived from the investor id, so a
 * second call resolves to the same account rather than stranding the first. That
 * is what makes it safe to offer as a plain button with no confirmation step.
 */
export function useCreateCustodyWalletMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (investorId: string) => createCustodyWallet(investorId),
    onSettled: (_result, _error, investorId) => {
      queryClient.invalidateQueries({
        queryKey: cryptoWalletsKeys.walletManagementDetail(investorId),
      })
      // The table shows the address and wallet status per row, so it moves too.
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.walletManagementLists() })
      queryClient.invalidateQueries({ queryKey: cryptoWalletsKeys.vaspWalletLists() })
    },
  })
}
